import { Instance } from 'mobx-state-tree'
import { TeachingTableRosterModelBase } from './TeachingTableRosterModel.base'

/* The TypeScript type of an instance of TeachingTableRosterModel */
export interface TeachingTableRosterModelType extends Instance<typeof TeachingTableRosterModel.Type> {}

/* A graphql query fragment builders for TeachingTableRosterModel */
export {
  selectFromTeachingTableRoster,
  teachingTableRosterModelPrimitives,
  TeachingTableRosterModelSelector
} from './TeachingTableRosterModel.base'

/**
 * TeachingTableRosterModel
 */
export const TeachingTableRosterModel = TeachingTableRosterModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
